// extracted by mini-css-extract-plugin
var _1 = "EditorCreateComment_input__80a49";
var _2 = "EditorCreateComment_me__00542";
var _3 = "EditorCreateComment_root__ebe72";
export { _1 as "input", _2 as "me", _3 as "root" }
